import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=7363fa1f&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=7363fa1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363fa1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7363fa1f')) {
      api.createRecord('7363fa1f', component.options)
    } else {
      api.reload('7363fa1f', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=7363fa1f&scoped=true&", function () {
      api.rerender('7363fa1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2ErrNOOJZ0V/JS/comp/DocBox.vue"
export default component.exports